const theme = {
  font: {
    primary: `'Canela', Times New Roman, serif`,
    secondary: `'Calibre', Arial, sans-serif`,
    cursive: `'Homemade Apple', cursive`,
  },
  font_size: {
    base: 'font-size: 16px; line-height: 125%',
    xxsmall: 'font-size: 0.625rem; line-height: 125%',
    xsmall: 'font-size: 0.75rem; line-height: 125%',
    small: 'font-size: 1rem; line-height: 125%',
    regular: 'font-size: 1.125rem; line-height: 125%',
    large: 'font-size: 1.25rem; line-height: 145%',
    xlarge: 'font-size: 1.5625rem; line-height: 145%',
    xxlarge: 'font-size: 2.625rem; line-height: 145%',
    xxxlarge: 'font-size: 3.625rem; line-height: 145%',
  },
  color: {
    white: {
      regular: 'rgba(255,255,255,1)',
      dark: 'rgba(255,255,255,0.6)',
      xdark: 'rgba(255,255,255,0.3)',
    },
    blue: {
      1: {
        dark: '#0A0A0A',
        light: '#A3A3A3',
      },
      2: {
        dark: '#2C2C2C',
        light: '#CBD1D6',
      },
      3: {
        dark: '#767676',
        light:
          'linear-gradient(145.04deg, #D7D2D2 -8.98%, #E7E7E7 42.32%, #DADADA 69.06%, #C6C3C3 116.98%, #9E9E9E 149.53%);',
      },
      card: '#414141',
      bg: '#EEEDED',
      gradient:
        'linear-gradient(355.43deg, #FFFFFF -340.65%, rgba(255, 255, 255, 0) 66.85%), #0B0B0B;',
    },
    black: {
      lighter: '#ABA8AF',
      light: '#564F62',
      regular: '#211E26',
    },
  },
  screen: {
    xs: '575px',
    sm: '767px',
    md: '1023px',
    lg: '1199px',
    xl: '1439px',
  },
};

export default theme;
